import React from 'react';
import { Footer } from '@clearchannelinternational/ecooh-system';
import { useTranslation } from 'react-i18next';

const FrameManagerFooter: React.FC<any> = ({ translate }) => {
  const { t } = useTranslation();

  const handleEmailClick = () => {
    const contactEmail = t('footer:contactEmail');
    window.location.href = `mailto:${contactEmail}`;
  };

  return (
    <div className="footer">
      <Footer
        logoSrc="bmo-logo-on-dark.png"
        logoAlt="Bauer Media Outdoor logo"
        logoHeight="35px"
        links={[
          {
            label: t('footer:contact'),
            onClick: handleEmailClick,
          },
        ]}
        copyright={`${t('footer:copyright')} ${new Date().getFullYear()}`}
      />
    </div>
  );
};

export default FrameManagerFooter;
